// Foundations
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

// rxjs
import { filter, finalize, take } from 'rxjs/operators';

// Services
import { MyProfileService } from 'src/app/services/my-profile.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { UpdatePreferredLocationGQL } from '../../../../services/graphql.service';
import { AuthService } from '../../../../auth/auth.service';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';

// Models
import { FranchiseLocation } from '../../../../models/franchise.model';
import { cloneAbstractControl } from 'src/app/shared/clone-abstract-control';

@Component({
  selector: 'app-edit-preferred-location',
  templateUrl: './edit-preferred-location.component.html',
  styleUrls: ['./edit-preferred-location.component.scss'],
})
export class EditPreferredLocationComponent implements OnInit {
  @Output() showCampLocationsList = new EventEmitter<number>();
  @Output() showCampLocationSearchSelect = new EventEmitter<number>();

  selectedId = new FormControl(null, Validators.required);
  selectedIdClone: FormControl;
  locationList: FranchiseLocation[];
  newOpt: FranchiseLocation;

  constructor(
    public myProfileService: MyProfileService,
    private _analytics: AnalyticsService,
    private updatePreferredLocationMutation: UpdatePreferredLocationGQL,
    private authService: AuthService,
    private loadingIndicatorService: LoadingIndicatorService
  ) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.myProfileService.locationList$.subscribe((locationList) => {
      this.locationList = locationList;
      this.selectedId.patchValue(locationList[0].id);
      this.selectedIdClone = cloneAbstractControl(this.selectedId);

      this.newOpt = this.myProfileService.newOptionFromSearch;
      if (this.newOpt) {
        this.myProfileService.newOptionFromSearch = null;
        this.selectedId.patchValue(this.newOpt.id);
        this.selectedId.markAsDirty();
      }
    });
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  changeSelectedLocationTile(locationId: string): void {
    this.selectedId.patchValue(
      locationId === this.selectedId.value ? null : locationId
    );
    this.selectedId.markAsDirty();
  }

  onSave(): void {
    this._analytics.logButtonTap('myProfile_savePreferredLocation');
    this.loadingIndicatorService.show();
    this.authService.accountId$
      .pipe(
        filter((accountId) => !!accountId),
        take(1)
      )
      .subscribe((accountId) => {
        this.updatePreferredLocationMutation
          .mutate({
            accountId,
            locationId: this.selectedId.value,
          })
          .pipe(finalize(() => this.loadingIndicatorService.hide()))
          .subscribe((res) => {
            if (res.data) {
              // Refetch the location info
              this.myProfileService.fetchLocationList();

              this.selectedId.markAsPristine();
              this.showCampLocationsList.emit(0);
            }
          });
      });
  }

  onCancel(): void {
    this.showCampLocationsList.emit(0);
  }

  isNewOptUnique(id: string): boolean {
    this.locationList.forEach((location) => {
      if (location.id === id) {
        return false;
      }
    });
    return true;
  }

  resetFormToDefault() {
    this.selectedId = cloneAbstractControl(this.selectedIdClone);
  }
}
